import { Button } from '@ui/button.tsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ui/card.tsx';
import { Link } from '@tanstack/react-router';

export const NotFoundError = () => {
  return (
    <>
      <div className="container flex flex-col h-full pt-10">
        <div className="z-10 flex max-w-[100%] flex-grow items-center sm:w-[505px]">
          <Card className="w-[100%]">
            <CardHeader>
              <CardTitle className="text-center">
                Oups, on dirait que vous vous êtes égaré(e) !
              </CardTitle>
              <CardDescription className="text-center">
                Pas de panique, même les explorateurs chevronnés se perdent parfois. Laissez-nous
                vous rediriger sur le bon chemin !
              </CardDescription>
            </CardHeader>

            <CardContent>
              <Link to="/">
                <Button className="w-full">Retour à l&apos;accueil</Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
      <div className="absolute bottom-0 w-screen">
        <div className="flex space-x-3">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 439 424" fill="none">
            <path
              d="M0.910645 430.103V322.815L205.551 0.953857H302.904V144.003H247.274L137.006 318.842V322.815H439V430.103H0.910645ZM248.267 509.575V397.32L251.247 350.631V0.953857H380.389V509.575H248.267Z"
              fill="#A8A29E"
            />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 430" fill="none">
            <path
              d="M224.547 529.482C178.354 529.317 138.452 518.638 104.842 497.445C71.232 476.252 45.3209 445.705 27.1085 405.804C8.89618 365.902 -0.127196 318.054 0.0383702 262.258C0.203937 206.296 9.31011 158.778 27.3569 119.705C45.5692 80.631 71.3976 50.9117 104.842 30.5471C138.452 10.1824 178.354 0 224.547 0C270.74 0 310.642 10.2651 344.252 30.7954C377.862 51.1601 403.773 80.8793 421.985 119.953C440.198 159.027 449.221 206.462 449.055 262.258C449.055 318.385 439.949 366.399 421.737 406.301C403.524 446.202 377.613 476.749 344.003 497.942C310.559 518.969 270.74 529.482 224.547 529.482ZM224.547 417.228C248.388 417.228 267.925 404.81 283.157 379.975C298.555 354.975 306.171 315.736 306.006 262.258C306.006 227.323 302.529 198.763 295.575 176.577C288.621 154.391 279.018 138 266.766 127.404C254.514 116.642 240.441 111.261 224.547 111.261C200.705 111.261 181.251 123.347 166.185 147.52C151.118 171.693 143.419 209.939 143.088 262.258C142.922 297.854 146.317 327.16 153.27 350.173C160.224 373.022 169.827 389.909 182.079 400.837C194.496 411.764 208.652 417.228 224.547 417.228Z"
              fill="#A8A29E"
            />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 439 424" fill="none">
            <path
              d="M0.910645 430.103V322.815L205.551 0.953857H302.904V144.003H247.274L137.006 318.842V322.815H439V430.103H0.910645ZM248.267 509.575V397.32L251.247 350.631V0.953857H380.389V509.575H248.267Z"
              fill="#A8A29E"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Error;
